import React from "react"
import PropTypes from "prop-types"
import { StatusIndicator } from "components-design-system"
import "./StatusBox.scss"

export const statusTypes = ["default", "processing", "success", "warning", "error"]

const StatusBox = ({ name, value, onClick, active = false, status, color, boxShadow, style, disabled = false }) => {
  return (
    <div
      style={style}
      className={`status-box${onClick && !disabled ? " hover-effect" : ""}${boxShadow ? " box-shadow-effect" : ""}${
        active ? " active box-shadow-effect" : ""
      }${disabled ? " disabled" : ""}`}
      onClick={!disabled ? onClick : undefined}
    >
      <span className="status-indicator-wrapper">
        {(status || color) && (
          <StatusIndicator
            bgColor={color}
            status={status}
          />
        )}
        <p className="status-box-title">{name && name}</p>
      </span>
      <span className="status-box-value">{value && value}</span>
    </div>
  )
}

StatusBox.propTypes = {
  /**
   * The **name** prop has a character limit when there is a status indicator. If the **name** is too long the status indicator will be squashed.
   */
  name: PropTypes.string,
  /**
   * The component has a fixed width, which limits the number of characters on the **value** prop string.
   */
  value: PropTypes.number.isRequired,
  /**
   * Adding an **onClick** function will give the component a hover effect.
   */
  onClick: PropTypes.func,
  active: PropTypes.bool,
  /**
   * The **status** prop will color the status indicator in one of the standard status colors.
   */
  status: PropTypes.oneOf(statusTypes),
  /**
   * To give the status indicator a custom color, the **color** prop can be provided a hex, RGB(A), HSL(A), HWB, HTML color name, or any other valid color string.
   *
   * To set a custom color, the **status** must be falsy.
   */
  color: PropTypes.string,
  /**
   * The **boxShadow** prop is used when adding the component to a gray background.
   */
  boxShadow: PropTypes.bool,
  /**
   * The disabled prop disables the onClick event and applies a disabled class for styling, making the StatusBox non-interactive and visually inactive when set to true.
   */
  disabled: PropTypes.bool,
  style: PropTypes.object,
}

export default StatusBox
